/* **************************************************** Finishing Shedule Tile Shop */
export interface FSTileShop {
    id: number;
    shop_name: string;
    created_by: number | null;
}

export const mapFSTileShop = (data: any): FSTileShop => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSTileShop = {
        id: data.id,
        shop_name: data.shop_name,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFSTileShops = (data: any[]): FSTileShop[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSTileShop);
};
